<template>
  <div class="link-item" :class="link.status">
    <div class="link-info">
      <mini-user
        :online="undefined"
        :fullname="link.target.name"
        :photo_url="link.target.photo_url"
        :username="link.target.username"
      />
      <div class="link-details">
        <span class="link-username" v-if="link.target.username">
          <a class="telegram-link" :href="`https://t.me/${link.target.username}`">
            @{{ link.target.username }}
          </a>
        </span>
        <span class="last-accessed">Last controlled {{ formatDate(link.last_accessed_at) }}</span>
        <span class="access-count">{{ link.access_count }} time(s)</span>
        <span
          v-if="link.status !== 'revoked' && link.current_session_status"
          class="session-status"
          :class="link.current_session_status"
        >
          {{ link.current_session_status }}
        </span>
        <span v-else class="session-status revoked"> &nbsp; </span>
      </div>
    </div>
    <div class="link-actions">
      <button
        v-if="link.status == 'active'"
        class="link-btn active"
        @click="emit('access', link.control_link_uuid)"
      >
        Control
      </button>
      <button
        v-if="link.status == 'past'"
        class="link-btn past"
        @click="emit('access', link.control_link_uuid)"
      >
        View
      </button>
      <button
        v-if="link.status == 'revoked'"
        class="link-btn revoked"
        @click="emit('access', link.control_link_uuid)"
        disabled
      >
        Revoked
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import { formatDate } from '@/utils/date'
import MiniUser from '@/components/MiniUser.vue'
import type { ControllerOut } from '@/schemas/schemas.ts'

export interface PreviousControlLinkOut {
  control_link_uuid: string
  target: ControllerOut
  last_accessed_at: string
  access_count: number
  status: 'active' | 'past' | 'revoked'
  current_session_status?: string | null
}

defineProps<{
  link: PreviousControlLinkOut
}>()
const emit = defineEmits<{
  (e: 'access', linkUuid: PreviousControlLinkOut['control_link_uuid']): void
}>()
</script>

<style scoped lang="scss">
.link-item {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  background: var(--color-background-soft);
  // cursor: pointer;
  transition: transform 0.2s;
  &.active {
    border-color: var(--session-active);
    background: var(--session-active-bg);
  }
  &.past {
    border-color: var(--session-past);
    background: var(--session-past-bg);
  }
  &.revoked {
    border-color: var(--session-revoked);
    background: var(--session-revoked-bg);
    opacity: 0.6;
  }
  .link-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .link-details {
      display: flex;
      flex-direction: column;
      // gap: 0.2em;
      align-items: center;
      text-align: center;

      .link-username {
        font-size: 0.875rem;
        color: var(--color-text-muted);
        margin-bottom: 0.25rem;
      }

      .link-uuid {
        font-size: 0.875rem;
        color: var(--color-text-muted);
        margin-bottom: 0.25rem;
      }

      .last-accessed,
      .access-count {
        font-size: 0.75rem;
        color: var(--color-text-muted);
      }
    }
  }
  .link-actions {
    margin-top: 0.5rem;

    .link-btn {
      background: #e67e22;
      color: #fff;
      padding: 0.4rem 0.8rem;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: filter 0.3s;
      &:hover {
        filter: brightness(0.9);
      }
      &[disabled]:hover {
        filter: none;
        cursor: not-allowed;
      }
      &.revoked {
        background: #000000;
        cursor: not-allowed;
      }
    }
  }
}
</style>
